export default __webpack_public_path__ + "static/media/ownr_direct.ed98c24d.svg";